import { Component } from 'react';

export class EventLogHandler extends Component {
  handleEventLog = event_params => {
    fetch(process.env.REACT_APP_BASEURL + 'events', {
      method: 'post',
      withCredentials: true,
      headers: {
        Authorization:
          'Bearer ' +
          JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken
            .jwtToken,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ ...event_params, audit_writer: 'web-gap-v1' })
    })
      .then(response => {
        try {
          return response.text();
        } catch (error) {
          return null;
        }
      })
      .then(evt_res => {
      });
  };
}
export default EventLogHandler;



// WEBPACK FOOTER //
// ./src/components/common/event-log-handler.js